
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"currentColor","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.281 0H3.72A3.719 3.719 0 000 3.719v9.562A3.719 3.719 0 003.719 17h9.562A3.719 3.719 0 0017 13.281V3.72A3.719 3.719 0 0013.281 0zm2.656 13.281a2.656 2.656 0 01-2.656 2.656H3.72a2.656 2.656 0 01-2.656-2.656V3.72A2.656 2.656 0 013.72 1.064h9.562a2.656 2.656 0 012.656 2.656v9.562z"}}),_c('path',{attrs:{"d":"M5.313 3.719H4.25a.531.531 0 00-.531.531v1.063c0 .293.238.53.531.53h1.063a.531.531 0 00.53-.53V4.25a.531.531 0 00-.53-.531zm0 3.719H4.25a.531.531 0 00-.531.53v1.063a.53.53 0 00.531.531h1.063a.531.531 0 00.53-.53V7.968a.531.531 0 00-.53-.532zm0 3.718H4.25a.531.531 0 00-.531.531v1.063c0 .293.238.531.531.531h1.063a.531.531 0 00.53-.531v-1.063a.531.531 0 00-.53-.53zm7.968-6.906H6.906v1.063h6.375V4.25zm0 3.719H6.906V9.03h6.375V7.97zm0 3.719H6.906v1.062h6.375v-1.063z"}})])
          )
        }
      }
    